// extracted by mini-css-extract-plugin
export default {"paye-header":"PayeReport_paye-header__OvqZQ","divider":"PayeReport_divider__KDjCG"};